module.exports.packages = {
  'aframe-environment': {
    components: ['environment'],
    script: 'https://hatchxr.com/aframe-environment-component.min.js'
  },
  'aframe-physics': {
    components: ['static', 'dynamic'],
    script: 'https://hatchxr.com/aframe-physics-system.min.js'
  },
  'aabb-collider': {
    components: [],
    script:
      'https://unpkg.com/aframe-aabb-collider-component@^2.2.1/dist/aframe-aabb-collider-component.min.js'
  },
  'aframe-extras': {
    components: [],
    script:
      'https://cdn.rawgit.com/donmccurdy/aframe-extras/v4.2.0/dist/aframe-extras.min.js'
  },
  'aframe-look-at-components': {
    components: [],
    script:
      'https://unpkg.com/aframe-look-at-component@0.5.1/dist/aframe-look-at-component.min.js'
  },
  'aframe-effects': {
    components: [],
    script: 'https://wizgrav.github.io/aframe-effects/dist/aframe-effects.js'
  },
  'super-craft': {
    components: [],
    script:
      'https://unpkg.com/aframe-supercraft-loader/dist/aframe-supercraft-loader.min.js'
  }
  //   'hatch-helper-functions': {
  //     components: [],
  //     script: 'https://hatchxr.com/hatch-helper-functions.js'
  //   }
};

module.exports.globalPackages = {
  'hatch-helper-functions': {
    components: [],
    script: 'https://dev.hatchxr.com/hatch-helper-functions.js'
  }
};
